// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1MUyP","inputDescription":"styles_inputDescription__5c53G"};